import "./styles.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import About from "./routes/About";
import Services from "./routes/Services";
import Portfolio from "./routes/Portfolio";
import Contact from "./routes/Contact";

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/servicos" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        {/* O portfólio esteve em /service até agora. Mantém-se o
            encaminhamento para não perder o que já esteja indexado nem
            partilhado em links antigos. */}
        <Route path="/service" element={<Navigate to="/portfolio" replace />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}
